import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthGate = ({ onSuccess }) => {
  const [token, setToken] = useState("");
  const [localtoken, setLocalToken] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const validateToken = async () => {
    setLoading(true);
    setError("");

    try {
      //for test server
      // const res = await fetch"https://pos.bookyep.com/tokenValidate"
      /* const res = await fetch("http://localhost:4000/tokenValidate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ token })
      }); */

      const res = await fetch("https://valley.bookyup.co.uk/tokenValidate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ token })
      });

      const data = await res.json();

      if (data.status === true) {
        sessionStorage.removeItem("redirected");
        localStorage.setItem("auth_token", token); // persist login
        navigate('/dashboard', { replace: true });
        window.location.reload();
        // handleClick();
        // window.location.href = "/dashboard";
        // onSuccess(token);
      } else {
        setError("Token is invalid or expired");
      }
    } catch (err) {
      setError("Server error. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ height: "100vh" }} className="d-flex justify-content-center align-items-center">
      <div style={{ width: 350 }}>
        <h4 className="text-center mb-3">Enter Access Token</h4>

        <input
          type="text"
          className="form-control mb-2"
          placeholder="Enter token"
          value={token}
          onChange={(e) => setToken(e.target.value)}
        />

        {error && <div className="text-danger mb-2">{error}</div>}

        <button
          className="btn btn-primary w-100"
          onClick={validateToken}
          disabled={loading}
        >
          {loading ? "Validating..." : "Submit"}
        </button>
      </div>
    </div>
  );
};

export default AuthGate;
